import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=0e68a077&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"
import style0 from "./Feedback.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Feedback.vue?vue&type=style&index=1&id=0e68a077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e68a077",
  null
  
)

export default component.exports